import { Radio } from 'antd';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './stylesChartNav.module.scss';

const ChartsTypeNav = ({ t, defaultValue, showSoilData, onChangeType }) => {
  return (
    <Radio.Group
      className={styles.chartsTypeNav}
      onChange={onChangeType}
      defaultValue={defaultValue}
      buttonStyle={'solid'}
    >
      <Radio.Button value="weather">
        <CroplerIcon name="weather" />
        <span>{t('charts.types.weather')}</span>
      </Radio.Button>
      <Radio.Button value="crop">
        <CroplerIcon name="plant" />
        <span>{t('charts.types.crop')}</span>
      </Radio.Button>
      {showSoilData && (
        <Radio.Button value="soil">
          <CroplerIcon name="shovel" />
          <span>{t('charts.types.soil')}</span>
        </Radio.Button>
      )}
      <Radio.Button value="custom">
        <CroplerIcon name="chart"/>
        <span>{t('charts.types.custom')}</span>
      </Radio.Button>
    </Radio.Group>
  );
};

export default ChartsTypeNav;
